// extracted by mini-css-extract-plugin
export default {"box_input":"Input_box_input__dPOAC","icon":"Input_icon__HtCC0","input":"Input_input__xC1Gr"};